export default function getSerialId() {
	const dateStr = new Date().valueOf().toString();
	const rndm = Math.floor(Math.random() * 100000 + 1).toString();
	return dateStr + rndm;
}
